import React from "react";
import { Offcanvas } from "react-bootstrap";
import SeparaterLine from "../../common/SeparaterLine";
import AddTraspButton from "../../firstTimeUserExperience/commonCom/AddTraspButton";
import AddButtonWithArrow from "../../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { FilterEntityEnum, ReportTypesEnum } from "@propertelligent/client-api";
import DateHelper from "../../../utils/DateHelper";
import CustomInputs from "../../common/Inputs";
import { useError } from "../../../utils/context/ErrorContext";

interface AddReportProps {
  title: string;
  show: boolean;
  handleClose: () => void;
  selectedValues: string[];
  selectedOption: FilterEntityEnum;
  range: { startDate: string; endDate: string }[];
  reportName: string;
  inputOnchange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddReport: (e: React.FormEvent<HTMLFormElement>) => void;
  relativeDateString: string;
  loading: boolean;
}

const AddReport: React.FC<any> = React.memo(
  ({
    title,
    show,
    handleClose,
    selectedValues,
    selectedOption,
    range,
    reportName,
    inputOnchange,
    handleAddReport,
    relativeDateString,
    loading,
  }) => {
    const reportType = parseInt(localStorage.getItem("ReportType"));
    const { errors, errorMessages } = useError();

    return (
      <Offcanvas
        className="offcanvas addReportCanvas"
        show={show}
        onHide={handleClose}
        placement="end"
        scroll={true}
      >
        <Offcanvas.Header closeButton className="canvasHeader">
          <Offcanvas.Title>{title}</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="filterFormContainer">
            <form className="reportFilterForm">
              <CustomInputs
                labelText="Report Name"
                type="text"
                name="reportName"
                placeholder="Report Name"
                value={reportName}
                onChange={inputOnchange}
                focus={true}
                required
                isError={errors.reportName}
                errorMessages={errorMessages.reportName}
                maxLength={30}
              />

              <div className="add_report_details">
                <div className="d-flex gap-1 justify-content-between">
                  <p className="sub_text fw-bold black">Type :</p>
                  <p className="sub_text black">
                    {reportType === ReportTypesEnum.Pnl
                      ? "Profit and loss"
                      : "Rent Roll"}
                  </p>
                </div>

                <div className="d-flex gap-1">
                  <span className="sub_text fw-bold black">Duration :</span>
                  <p className="sub_text black">
                    {relativeDateString !== "Custom"
                      ? relativeDateString
                      : `${DateHelper.convertUTCtoDateTimeSimple(range[0].startDate)} - ${DateHelper.convertUTCtoDateTimeSimple(range[0].endDate)}`}
                  </p>
                </div>

                <div className="d-flex gap-1">
                  <span className="sub_text fw-bold black">
                    Generate report for :
                  </span>
                  <p className="sub_text black">
                    {selectedOption === FilterEntityEnum.Property
                      ? "Properties"
                      : selectedOption === FilterEntityEnum.Unit
                        ? "Units"
                        : selectedOption === FilterEntityEnum.Organization
                          ? "Organization"
                          : ""}
                  </p>
                </div>
              </div>

              {Number(selectedOption) !== FilterEntityEnum.Organization && (
                <div>
                  <div className="d-flex gap-2 align-items-center mt-4 mb-3 add_report_properties">
                    <SeparaterLine height={"18px"} background={"#111928"} />
                    <p className="text-uppercase sub_text black">
                      {selectedOption === FilterEntityEnum.Property
                        ? "Properties Included"
                        : selectedOption === FilterEntityEnum.Unit
                          ? "Units Included"
                          : ""}
                    </p>
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    {selectedValues?.map((value, i) => (
                      <p
                        key={i}
                        className="selectedValueLabel normal_text"
                        style={{ fontSize: "12px" }}
                      >
                        {value}
                      </p>
                    ))}
                  </div>
                </div>
              )}
            </form>

            <div className="filterFormButton">
              <AddTraspButton
                type="button"
                bname={"Cancel"}
                onClick={handleClose}
                width="fit-content"
              />
              <AddButtonWithArrow
                buttonname={"Save"}
                onClick={handleAddReport}
                disabled={loading}
                minWidth="fit-content"
                loading={loading}
              />
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    );
  },
);

export default AddReport;
